import InitPlugin from "../../../../helpers/InitPlugin";

const Step_1 = () => {
  return <InitPlugin />;
};

export default Step_1;
